<template>
  <div class="message" @click="hidemessage">
    <div class="messagecon"><img src="../../assets/tip.png" />{{message}}</div>
  </div>
</template>
<script>
export default {
  props: [
    'message'
  ],
  methods: {
    hidemessage() {
      this.$emit("hidemessage")
    }
  }
}
</script>
<style scoped>
  .message {
    position: fixed;
    left: 0;
    right: 0;
    top:0;
    bottom: 0;
    background: rgba(0,0,0,.7);
  }
  .messagecon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 68vw;
    height: 18vw;
    background: url("../../assets/messagebg.png") no-repeat;
    background-size: contain;
    color: #fff;
    line-height: 18vw;
    text-align: center;
    font-size: 3.5vw;
  }
  .messagecon img {
    vertical-align: middle;
    width: 5vw;
    margin-right: 2vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/message.vue